module.exports = __webpack_public_path__ + "static/img/sogou.41bfa714.png";